export default "__VITE_ASSET__Dtca1n5z__"